export default __webpack_public_path__ + "static/media/zdj1.d77a9f79.JPG";